import { render } from "./ChatMessage.vue?vue&type=template&id=66271c77"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=66271c77&lang=scss"
script.render = render

export default script